import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";

import GroupAddOutlinedIcon from "@mui/icons-material/GroupAddOutlined";
import JoinGroupDialog from "./JoinGroupDialog";
import { useTranslation } from "react-i18next";

function JoinGroupButton() {
  const [open, setOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div>
      <ListItem button onClick={() => setOpen(true)} sx={{ borderRadius: 1 }}>
        <ListItemIcon>
          <GroupAddOutlinedIcon />
        </ListItemIcon>
        <ListItemText
          primary={
            <Typography variant="body2">{t("library.buttons.join")}</Typography>
          }
        />
      </ListItem>
      <JoinGroupDialog open={open} setOpen={setOpen} />
    </div>
  );
}

export default JoinGroupButton;
